import { toast } from "react-toastify";
import axios from "axios";
import { ProjectState } from "../ViewModel/ProjectState";
import { TransitionNavigationParameter } from "./TransitionNavigationParameter";
import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import { RouteState } from "../ViewModel/RouteState";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { projectStateTransitionApiUrls } from "../../URL/ApplicationUrls";

function updateState(
  project: ProjectViewModel,
  setProject: (updateProject: ProjectViewModel) => void,
  routeState: RouteState,
  projectState: ProjectState,
  showSpdrsInOverview: boolean
) {
  const changeFTLRoute = project?.FTLRoutes?.map(
    (element: FtlRouteViewModel) => {
      return {
        ...element,
        State: routeState,
      };
    }
  );

  setProject({
    ...project,
    State: projectState,
    ShowSpdrsInOverview: showSpdrsInOverview,
    FTLRoutes: changeFTLRoute,
  });
}

export async function gotoNextProjectState(
  requestedState: TransitionNavigationParameter,
  project: ProjectViewModel,
  setProject: (updateProject: ProjectViewModel) => void
) {
  async function post() {
    const data = {
      projectId: project.ProjectId,
      requestedState,
    };

    const response = await axios.post(
      projectStateTransitionApiUrls.gotoNextProjectState,
      data
    );
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    const json: any = response.data;
    if (!json.Success) {
      throw new Error(`Receive Response, but got Error: ${json.ErrorMessage}`);
    }

    updateState(
      project,
      setProject,
      json.Data.NewState,
      json.Data.Result.ProjectState,
      json.Data.Result.ShowSpdrsInOverview
    );
  }

  return toast.promise(post(), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: "State changed",
  });
}
